import React from 'react';
import { Container, Box, Typography, Button } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';

const SurveyComplete: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation() as any;
  const message: string | undefined = location?.state?.message;

  return (
    <Container className="survey-complete-page" maxWidth="sm" sx={{ py: 8 }}>
      <Box textAlign="center">
        <Typography variant="h4" component="h1" gutterBottom>
          Thank you!
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          {message || 'Your responses have been submitted successfully.'}
        </Typography>
        <Button variant="contained" onClick={() => navigate('/dashboard')}>
          Go to Dashboard
        </Button>
      </Box>
    </Container>
  );
};

export default SurveyComplete;
